import TabPage from "./../factories/tab-page";
import BaseViewModelModule from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
class ShiftPlanModel extends BaseViewModelModule {
    constructor(tabPage: TabPage) {
        super(tabPage);
    }
    //ConfigurationItemTypeTab: Factories.TabPage;
    //ConfigurationItemTypeTabTitle = ko.observable<string>();     
    //TabController = new TabController(false);
    ShiftPlanModelId: KnockoutObservable<any>;
    ShiftPlanModelDetailTab: TabPage;
    ShiftPlanModelShiftGroupTab: Factories.TabPage;
    ShiftPlanModelPreviewTab: Factories.TabPage;
    _saveInvalidShiftpatternMessage = Bao.Session.GetMessage("msgInvalidShiftpattern");

    CompleteCheck() {
        var isComplete: boolean = true;
        //if (!isComplete) {
        //    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        //}
        return isComplete;
    }

    InitUrl() {
        return "ShiftPlanModel/Init";
    }

    loaded() {
        super.loaded();
        //this.ConfigurationItemTypeTab = new TabPage();
        //this.ConfigurationItemTypeTab.Url("ActivityType/ConfigurationItemTypeTab");
        //this.TabController.AddTab(this.ConfigurationItemTypeTab);
    }

    init() {
        var def = $.Deferred<void>();
        super.init().then(() => {
            super.InitTabController().then(() => {
                this.ShiftPlanModelDetailTab = new TabPage();
                this.ShiftPlanModelDetailTab.IsClosable(false);
                this.ShiftPlanModelDetailTab.AutoSelect = false;
                this.ShiftPlanModelDetailTab.Url("ShiftPlanModelDetailTab");
                this.TabController.AddTab(this.ShiftPlanModelDetailTab);

                this.ShiftPlanModelShiftGroupTab = new TabPage();
                this.ShiftPlanModelShiftGroupTab.IsClosable(false);
                this.ShiftPlanModelShiftGroupTab.AutoSelect = true;
                this.ShiftPlanModelShiftGroupTab.Url("ShiftPlanModelShiftGroupTab");
                this.TabController.AddTab(this.ShiftPlanModelShiftGroupTab);

                this.ShiftPlanModelPreviewTab = new TabPage();
                this.ShiftPlanModelPreviewTab.IsClosable(false);
                this.ShiftPlanModelPreviewTab.AutoSelect = false;
                this.ShiftPlanModelPreviewTab.Url("ShiftPlanModelPreviewTab");
                this.TabController.AddTab(this.ShiftPlanModelPreviewTab);

                def.resolve();
            });
        });
        return def.promise();
    }

    Save(): JQueryPromise<void> {
        let def = $.Deferred<void>();
        Bao.post("ShiftPlanModel/ValidateShiftPattern", JSON.stringify({
            sessionTabId: this.TabPage.SessionTabId,
            shiftPlanModelId: this.ShiftPlanModelId()
        })).then((result) => {
            if (result === true) {
                super.Save().then(() => {
                    def.resolve();
                });
            }
            else {
                let yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, this._saveInvalidShiftpatternMessage, "yesno");
                yesNoDialog.DialogResult.subscribe((dialogResult) => {
                    if (dialogResult === true) {
                        super.Save().then(() => {
                            def.resolve();
                        });
                    }
                    else {
                        def.resolve();
                    }
                });
            }
        });
        return def.promise();
    }
}
export default ShiftPlanModel;